import styled from "styled-components";

export default styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  .navbar {
    width: 230px;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .aitem {
      width: 220px;
      height: 120px;
      margin: 5px 0;
      margin-left: 5px;
    }
  }
  .main {
    flex: 1;
    position: relative;
    .wb {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
  .sidemain {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .prev {
    margin-bottom: 10px;
  }
  .next {
    margin-top: 10px;
  }
`;
